<template>
  <div class="home-reports">
    <Row :gutter="8">
      <Col :lg="12" style="margin-top: 8px">
        <Card shadow style="height: 300px" :title="`域名平台统计（总数：${domainAllCount}）`">
          <Spin fix v-show="platformDataLoading"></Spin>
          <Alert type="error" v-if="platformDataError" show-icon>获取数据失败</Alert>
          <div id="pie_asset_domain_id" style="width: 100%; height: 230px;" v-else></div>
        </Card>
      </Col>
      <Col :lg="12" style="margin-top: 8px">
        <Card shadow style="height: 300px" title="域名账号统计" class="no-padding-card-body">
          <div>
            <Alert type="error" v-if="accountCount.error" show-icon style="margin: 16px;">获取数据失败</Alert>
            <Table
              v-else
              :columns="accountCount.columns"
              :data="accountCount.data"
              max-height="265"
              size="small"
              :loading="accountCount.loading"></Table>
          </div>
        </Card>
      </Col>
      <Col :lg="24" style="margin-top: 8px">
        <Card shadow style="height: 480px" class="no-padding-card-body">
          <p slot="title">
            <span>即将过期域名（总数：<a style="color: red" v-on:click="$router.push({name: 'domain_lst'})">{{ expiringCount.data.length }}</a>）</span>
          </p>
          <div>
            <Alert type="error" v-if="expiringCount.error" show-icon style="margin: 16px;">获取数据失败</Alert>
            <Table
              v-else
              :columns="expiringCount.columns"
              :data="expiringCount.data"
              max-height="450"
              size="small"
              :loading="expiringCount.loading"></Table>
          </div>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>
import { getDomainPlatform, getDomainAccount, getDomainExpire } from '@/api/opscenter'
import echarts from '@/view/monitor/components/echarts-use.js'

export default {
  name: 'domain',
  data () {
    return {
      pieOption: {
        title: {
          text: '域名平台统计',
          x: 'center',
          show: false
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          data: [],
          show: false
        },
        series: [
          {
            name: '平台',
            type: 'pie',
            radius: '55%',
            center: ['50%', '60%'],
            data: [],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            label: {
              normal: {
                formatter: '{b|{b}：}{c}  {per|{d}%}\n  ',
                rich: {
                  a: {
                    color: '#999',
                    lineHeight: 15,
                    align: 'center'
                  },
                  b: {
                    fontSize: 12
                  },
                  per: {
                    color: '#eee',
                    backgroundColor: '#334455',
                    padding: [2, 4],
                    borderRadius: 2
                  }
                }
              }
            }
          }
        ]
      },
      domainAllCount: 0,
      platformDataLoading: false,
      platformDataError: false,
      accountCount: {
        error: false,
        loading: false,
        columns: [
          { title: '账号', key: 'username', align: 'center' },
          { title: '平台', key: 'registrar', align: 'center' },
          { title: '域名总数', key: 'total', align: 'center' },
          {
            title: '即将过期数',
            key: 'expire_num',
            align: 'center',
            render: (h, params) => {
              return h('span', {
                style: {
                  color: 'red'
                }
              }, params.row.expire_num)
            }
          }
        ],
        data: []
      },
      expiringCount: {
        error: false,
        loading: false,
        columns: [
          { title: '域名', key: 'name', align: 'center' },
          { title: '平台', key: 'registrar', align: 'center' },
          { title: '所属账号', key: 'username', align: 'center' },
          {
            title: '到期时间',
            key: 'time_expire',
            align: 'center',
            render: (h, params) => {
              return h('span', {
                style: {
                  color: 'red'
                }
              }, params.row.time_expire)
            }
          }
        ],
        data: []
      }
    }
  },
  created: function () {
    this.getDomainPlatformData()
    this.getDomainAccountCount()
    this.getExpiringDomainCount()
  },
  methods: {
    getDomainPlatformData () {
      this.platformDataError = false
      this.platformDataLoading = true
      getDomainPlatform().then(res => {
        for (let i in res.data.data) {
          this.domainAllCount += res.data.data[i].total
        }
        this.pieOption.legend.data = res.data.data.map(item => item.registrar)
        this.pieOption.series[0].data = res.data.data.map(item => {
          return {name: item.registrar, value: item.total}
        })
        let domainPlatformPie = echarts.init(document.getElementById('pie_asset_domain_id'), 'roma')
        window.addEventListener('resize', function () {
          domainPlatformPie.resize()
        })
        domainPlatformPie.clear()
        domainPlatformPie.setOption(this.pieOption, true)
        this.platformDataLoading = false
      }).catch(res => {
        this.platformDataLoading = false
        this.platformDataError = true
        console.error(res)
      })
    },
    getDomainAccountCount () {
      let params = {
        time: 30
      }
      this.accountCount.error = false
      this.accountCount.loading = true
      getDomainAccount(params).then(res => {
        this.accountCount.loading = false
        this.accountCount.data = res.data.data
      }).catch(res => {
        this.accountCount.loading = false
        this.accountCount.error = true
        console.error(res)
      })
    },
    getExpiringDomainCount () {
      let params = {
        ordering: 'time_expire',
        time: 30
      }
      this.expiringCount.error = false
      this.expiringCount.loading = true
      getDomainExpire(params).then(res => {
        this.expiringCount.loading = false
        this.expiringCount.data = res.data.data
      }).catch(res => {
        this.expiringCount.loading = false
        this.expiringCount.error = true
        console.error(res)
      })
    }
  }
}
</script>

<style lang="less">
</style>
